import { render, staticRenderFns } from "./NutricaoPacientes.vue?vue&type=template&id=1a5ff19d&scoped=true&"
import script from "./NutricaoPacientes.vue?vue&type=script&lang=js&"
export * from "./NutricaoPacientes.vue?vue&type=script&lang=js&"
import style0 from "./NutricaoPacientes.vue?vue&type=style&index=0&id=1a5ff19d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a5ff19d",
  null
  
)

export default component.exports